/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { forwardRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../redux/rootState';
import { PDFResponse } from '../UnscheduledJobs/addJob/components/ReportListingModal/Type';
import { convertDateFormatTo } from '../../../utils/CommonFunctions';

const ComponentLetterToPrint = forwardRef<HTMLDivElement>((props, ref) => {
  const { schedulingPdfResponse } = useSelector((state: RootState) => state.jobScheduleReducer);
  const { jobId } = useParams();

  const data = useMemo(() => {
    const res = [];
    const len = schedulingPdfResponse?.length;
    if (len > 0) {
      for (let i = 0; i < len;) {
        res.push(schedulingPdfResponse?.slice(i, i + 4));
        i += 4;
      }
      return res;
    } return [];
  }, [schedulingPdfResponse]);

  const [isTravelDataAvailable, isSecondPage] = useMemo(() => {
    const stack = schedulingPdfResponse?.[0];
    const isTravelData = stack?.FlightOutAirlines?.length > 0 || stack?.FlightOutDate?.length > 0 || stack?.FlightOutDepartureTime?.length > 0 || stack?.ToOut?.length > 0 || stack?.FlightOutArrivalTime?.length > 0 || Number(stack?.FlightOutSeat) > 0
    || stack?.FlightInAirlines?.length > 0 || stack?.FlightInDate?.length > 0 || stack?.FlightInDepartureTime?.length > 0 || stack?.ToIn?.length > 0 || stack?.FlightInArrivalTime?.length > 0 || Number(stack?.FlightInSeat) > 0
    || stack?.CarRentalCompany?.length > 0 || stack?.CarRentalPhone?.length > 0 || stack?.CarRentalConfirmationNumber?.length > 0 || Number(stack?.CarRentalPrice) > 0 || stack?.CarRentalInstruction?.length > 0;

    const isSecond = isTravelData
    // || schedulingPdfResponse?.[0]?.Direction?.length > 0
    || schedulingPdfResponse?.[0]?.HotelAccomodation?.length > 0;

    return [isTravelData, isSecond];
  }, [schedulingPdfResponse]);

  return (
    <div ref={ref} className="printable-content">
      {data?.map((d, index) => (
        <>
          <div className="w100 p20">
            <div className="letter_top_section">
              <div className="top_section_item borderR w33">
                {/* <p className="heading_text underline">*Analyst Name*</p> */}
                <p className="heading_text underline">Job Number: {`${d?.[0]?.SiteState || ''}${jobId || ''}`}</p>
                <p className="letter_text">Trip Number: 1</p>
              </div>
              <div className="top_section_item borderR w33">
                <p className="heading_text underline">Contractor</p>
                <p className="letter_text">{d?.[0]?.CustName || '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.CustAddress || '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.CustOptionalAddress || '\u00A0'}</p>
                <p className="letter_text">{`${d?.[0]?.CustCity?.length > 0 ? `${d?.[0]?.CustCity},` : ''} ${d?.[0]?.CustState || ''} ${d?.[0]?.CustZipCode || ''} ${d?.[0]?.CustCountry || '\u00A0'}`}</p>
                <p className="letter_text">{d?.[0]?.ContractorName || '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.ContractorPhone?.length > 0 ? `${d?.[0]?.ContractorPhone} (Phone)` : '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.ContractorCell?.length > 0 ? `${d?.[0]?.ContractorCell} (Cell)` : '\u00A0'}</p>
              </div>
              <div className="top_section_item">
                <p className="heading_text underline">Job Site</p>
                <p className="letter_text">{d?.[0]?.SiteName || '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.SiteAddress || '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.SiteOptionalAddress || '\u00A0'}</p>
                <p className="letter_text">{`${d?.[0]?.SiteCity?.length > 0 ? `${d?.[0]?.SiteCity},` : ''} ${d?.[0]?.SiteState || ''} ${d?.[0]?.SiteZipCode || ''} ${d?.[0]?.SiteCountry || '\u00A0'}`}</p>
                <p className="letter_text">{d?.[0]?.SiteContactName || '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.SitePhone?.length > 0 ? `${d?.[0]?.SitePhone} (Phone)` : '\u00A0'}</p>
                <p className="letter_text">{d?.[0]?.SiteCell?.length > 0 ? `${d?.[0]?.SiteCell} (Cell)` : '\u00A0'}</p>
              </div>
            </div>
            <div className="letter_unit_section">
              {d?.map((item: PDFResponse, i: number) => (
                <div className={`unit_section_item ${i < d.length - 1 ? 'borderR' : ''} ${i === 3 ? '' : 'w24'}`}>
                  {/* <p className="heading_text underline" style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>AKASH sIGHN GUPTA, LEVEL III</p> */}
                  <p className="heading_text underline" style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>{item?.AnalystName?.toUpperCase() || '\u00A0'}</p>
                  <p className="letter_heading_text">JOB ORDER: <span>{item?.JobOrder || ''}</span></p>
                  <p className="letter_heading_text">
                    PO Number: <span>{item?.PONumber || ''}</span>
                  </p>
                  <p className="letter_heading_text">Location: <span>{item?.UnitLocation || ''}</span></p>
                  <p className="letter_heading_text">Dates: <span>{`${item?.UnitDateStart || ''} to ${item?.UnitEndDaten || ''}`}</span></p>
                  <p className="letter_heading_text">Job Time: <span>{item?.UnitJobTime || ''}</span></p>
                  <p className="letter_heading_text">Manufacturer: <span>{item?.UnitManufacture || ''}</span></p>
                  <p className="letter_heading_text">Model: <span>{item?.UnitModel || ''}</span></p>
                  <p className="letter_heading_text">Type: <span>{item?.UnitType || ''}</span></p>
                  <p className="letter_heading_text">S/N: <span>{item?.UnitSerialNumber || ''}</span></p>
                  <p className="letter_heading_text">Tested Before: <span>{item?.UnitTestedBefore ? 'Yes' : 'No'}</span></p>
                  <p className="letter_heading_text">Leaking: <span>{item?.UnitLeaking ? 'Yes' : 'No'}</span></p>
                  <div className="vessel_list_container">
                    <div className="column_align">
                      {item?.VesselTubeCount?.map((vessel) => (
                        <p className="letter_heading_text">{vessel?.VesselName}:<span> {vessel?.TubeCount}</span></p>
                      ))}
                    </div>
                    <p className="letter_heading_text align_end">Total:<span> {item?.VesselTubeCount.reduce((sum, subItem) => sum + Number(subItem.TubeCount || 0), 0)}</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
            {schedulingPdfResponse?.[0]?.Direction?.length > 0 && <p className="heading_text underline direction_heading">DIRECTIONS/COMMENTS</p>}
            {schedulingPdfResponse?.[0]?.Direction?.length > 0 && (
            <div className="directions">
              <p style={{ whiteSpace: 'pre-line' }}>{schedulingPdfResponse?.[0]?.Direction || ''}</p>
            </div>
            )}
          </div>
          {(index < (data.length - 1)
            // || schedulingPdfResponse?.[0]?.Direction?.length > 0
            || schedulingPdfResponse?.[0]?.HotelAccomodation?.length > 0
            || isTravelDataAvailable) && <div className="page-break" />}
        </>
      ))}

      {/* Second page */}
      {isSecondPage && (
      <div className="w100 p40 column_align">
        {/* {schedulingPdfResponse?.[0]?.Direction?.length > 0 && <p className="heading_text underline direction_heading">DIRECTIONS/COMMENTS</p>}
        {schedulingPdfResponse?.[0]?.Direction?.length > 0 && (
        <div className="directions">
          <p style={{ whiteSpace: 'pre-line' }}>{schedulingPdfResponse?.[0]?.Direction || ''}</p>
        </div>
        )} */}
        {schedulingPdfResponse?.[0]?.HotelAccomodation?.length > 0 && (
        <div className="row_align hotel_header">
          <p style={{ width: '30%' }}>Hotel</p>
          <p style={{ width: '10%' }}>Date In</p>
          <p style={{ width: '10%' }}>Date Out</p>
          <p style={{ width: '10%' }}>Late</p>
          <p style={{ width: '10%' }}>Price</p>
          <p style={{ width: '18%' }}>Phone</p>
          <p style={{ width: '12%' }}>Confirmation</p>
        </div>
        )}
        {schedulingPdfResponse?.[0]?.HotelAccomodation?.length > 0 && schedulingPdfResponse?.[0]?.HotelAccomodation?.map((hotel) => (
          <div className="row_align center_align hotel_record">
            <p style={{ width: '30%', whiteSpace: 'pre-line' }}>
              {`${hotel?.HotelName || ''}${hotel?.HotelName?.length > 0 ? '\n' : ''}${hotel?.Address || ''}${hotel?.Address?.length > 0 ? '\n' : ''}${hotel?.OptionalAddress || ''}${hotel?.OptionalAddress?.length > 0 ? '\n' : ''}${hotel?.CityName?.length > 0 ? `${hotel?.CityName},` : ''} ${hotel?.State || ''} ${hotel?.ZipCode || ''} ${hotel?.CountryCode || ''}`}
            </p>
            <p style={{ width: '10%' }}>{hotel?.DateIn || ''}</p>
            <p style={{ width: '10%' }}>{hotel?.DateOut || ''}</p>
            <p style={{ width: '10%' }}>{hotel?.Late ? 'Yes' : ''}</p>
            <p style={{ width: '10%' }}>{hotel?.Price || ''}</p>
            <p style={{ width: '18%' }}>{hotel?.PhoneNumber || ''}</p>
            <p style={{ width: '12%' }}>{hotel?.ConfirmationCode || ''}</p>
          </div>
        ))}
        {/* {schedulingPdfResponse?.[0]?.HotelAccomodation?.length === 0 && (
          <div className="row_align center_align hotel_record">
            <p style={{ width: '30%', whiteSpace: 'pre-line' }}>{' '}</p>
            <p style={{ width: '10%' }}>{' '}</p>
            <p style={{ width: '10%' }}>{' '}</p>
            <p style={{ width: '10%' }}>{' '}</p>
            <p style={{ width: '10%' }}>{' '}</p>
            <p style={{ width: '18%' }}>{' '}</p>
            <p style={{ width: '12%' }}>{' '}</p>
          </div>
        )} */}
        {isTravelDataAvailable && (
        <div className="row_align analyst_travel_info">
          <div style={{ width: '11%', paddingTop: '34px' }}>
            <p>Airline #:</p>
            <p>Dep/Date:</p>
            <p>Dep/Time:</p>
            <p>Arr/Date:</p>
            <p>Arr/Time:</p>
            <p>$/Seat:</p>
          </div>
          <div style={{ width: '26%' }}>
            <p className="underline fw600">Flight Out</p>
            <p>&nbsp;</p>
            <p>{schedulingPdfResponse?.[0]?.FlightOutAirlines || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightOutDate || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightOutDepartureTime || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.ToOut ? convertDateFormatTo(schedulingPdfResponse?.[0]?.ToOut) : '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightOutArrivalTime || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightOutSeat || '\u00A0'}</p>
          </div>
          <div style={{ width: '26%' }}>
            <p className="underline fw600">Flight In</p>
            <p>&nbsp;</p>
            <p>{schedulingPdfResponse?.[0]?.FlightInAirlines || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightInDate || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightInDepartureTime || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.ToIn ? convertDateFormatTo(schedulingPdfResponse?.[0]?.ToIn) : '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightInArrivalTime || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.FlightInSeat || '\u00A0'}</p>
          </div>
          <div style={{ width: '11%', paddingTop: '34px' }}>
            <p>Car:</p>
            <p>Phone:</p>
            <p>Conf #:</p>
            <p>Price:</p>
            <p>Instructions:</p>
          </div>
          <div style={{ width: '26%' }}>
            <p className="underline fw600">Car Rental</p>
            <p>&nbsp;</p>
            <p>{schedulingPdfResponse?.[0]?.CarRentalCompany || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.CarRentalPhone || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.CarRentalConfirmationNumber || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.CarRentalPrice || '\u00A0'}</p>
            <p>{schedulingPdfResponse?.[0]?.CarRentalInstruction || '\u00A0'}</p>
          </div>
        </div>
        )}
      </div>
      )}
    </div>
  );
});

export default ComponentLetterToPrint;
